import PredictionsViewDialog from './PredictionsViewDialog';

export default PredictionsViewDialog;
